module.exports = {"341521100":"寿春镇","341521101":"双桥镇","341521102":"涧沟镇","341521103":"丰庄镇","341521104":"正阳关镇","341521105":"迎河镇","341521106":"板桥镇","341521107":"安丰塘镇","341521108":"堰口镇","341521109":"保义镇","341521110":"隐贤镇","341521111":"安丰镇","341521112":"众兴镇","341521113":"茶庵镇","341521114":"三觉镇","341521115":"炎刘镇","341521116":"刘岗镇","341521117":"双庙集镇","341521118":"小甸镇","341521119":"瓦埠镇","341521120":"大顺镇","341521121":"窑口镇","341521200":"八公山乡","341521201":"张李乡","341521203":"陶店回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341521.json
// module id = 1140
// module chunks = 0